module.exports = __webpack_public_path__ + "img/header-diamondJewelryGold@2x.13b99da.jpg";